import {Component} from 'react';
import axios from "axios";
import {apiConfigs, headers} from '../Config';


class Api extends Component {
    constructor(props) {
        super(props);
        axios.defaults.baseURL = apiConfigs.baseURL;
        axios.defaults.timeout = 30000;
    }

    // Home Page
    getDestination = (id) => {
        return axios.get(`ships/get-destination/${id}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    // Home Page
    getDestinations = () => {
        return axios.get(`ships/get-destinations`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getStates = (code = 'CA') => {
        return axios.get(`ships/get-states/${code}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getCities = (id = 1) => {
        return axios.get(`ships/get-cities/${id}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    getQuote = (request) => {
        return axios.post('ships/get-quote/', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    login = (request) => {
        return axios.post('ships/login-user/', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    register = (request) => {
        return axios.post('ships/register-user/', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    checkUser = (request) => {
        return axios.post('ships/check-user/', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    saveRequest = (request) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
        return axios.post('ships/requests/', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    payment = (request) => {
        return axios.post('ships/payment/', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getRequests = (params = null) => {
        return axios.get('ships/requests/', {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getRequest = (id, params = null) => {
        return axios.get('ships/requests/' + id, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    cancelRequest = (id, params = null) => {
        return axios.get('ships/cancel-request/' + id, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getUser = (params = null) => {
        return axios.get('ships/user-info/', {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getContent = (slug) => {
        return axios.get('contents/' + slug, {
            headers,
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    updateUser = (request) => {
        return axios.post('ships/update-profile/', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

}

const API = new Api();
export default API;